module.exports = __webpack_public_path__ + "a8a10a3e/img/link-icon.fa09ed66.svg";